import * as React from "react";
import * as ReactDOM from "react-dom";

import { ServicesView } from "./components/ServicesView";

ReactDOM.render(
  <ServicesView />, document.getElementById("react_root")
);
